<app-timeline
  [actions]="[{id: 'request', label: ('Shipments.Request' | translate)}, {id: 'response', label: ('Shipments.Response' | translate)}]"
  [list]="translatedLogList"
  (actionClicked)="handleClickedAction($event)"
  [handleEmptyRequestState]="handleEmptyRequestState"
  [emptyRequestActions]="[{id: 'missing_data', label: ('Shipments.MissingData' | translate)}]"
></app-timeline>

<app-modal
  #requestModal
  [title]="selectedItem?.label"
  [subTitle]=" selectedAction === 'missing_data' ? 'response' : selectedAction"
  [maxWidth]="800"
  [padding]="20"
  [textColor]="'var(--color-dark)'"
  
>
  <div *ngIf="requestModal.isModalOpened && selectedItem">
    <app-state-section [state]="selectedItemState">
      <app-request-and-response-log
        [selectedItem]="selectedItem"
        [selectedItemPayload]="selectedItemPayload"
        (closeModal)="requestModal.closeModal()"
      ></app-request-and-response-log>
    </app-state-section>
  </div>
</app-modal>
